import { render, staticRenderFns } from "./LookLiushui.vue?vue&type=template&id=47392d3b&scoped=true&"
import script from "./LookLiushui.vue?vue&type=script&lang=js&"
export * from "./LookLiushui.vue?vue&type=script&lang=js&"
import style0 from "./LookLiushui.vue?vue&type=style&index=0&id=47392d3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47392d3b",
  null
  
)

export default component.exports